export const INFO_PORTAL_ALL = "*@reports";